import React from "react";
import { Award, Compass, HeartPulse } from "lucide-react";

const COACH_IMG = "/coach/ashley.jpg";

const CREDS = [
  { icon: Award, label: "Bachelor of Exercise and Movement Science" },
  { icon: HeartPulse, label: "Level 1 Athletics Australia Running Coach" },
  { icon: Compass, label: "5K · 15:47   |   10K · 33:15   |   Half · 1:12:01" },
];

export default function CoachAbout() {
  return (
    <section
      id="coach"
      data-testid="coach-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="absolute inset-0 tech-grid opacity-40 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
              <img
                src={COACH_IMG}
                alt="Coach Ashley Kempson"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-6 -right-2 lg:-right-8 bg-brand-red text-white px-6 py-4 max-w-[280px]">
              <div className="font-mono text-[10px] tracking-widest uppercase opacity-90">
                Head Coach
              </div>
              <div className="font-display text-2xl tracking-wide uppercase leading-none mt-1">
                Ashley Kempson
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-mono text-brand-red text-xs tracking-widest">02</span>
              <span className="label-eyebrow">The Coach</span>
            </div>
            <h2 className="font-display uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tight">
              I coach runners who refuse to <span className="text-brand-red">guess.</span>
            </h2>

            <div className="mt-8 space-y-5 text-white/70 text-base lg:text-lg leading-relaxed max-w-2xl">
              <p>
                Maximising your progress isn't about training harder — it's about hitting
                the right sessions at the right intensity. This will shift depending on
                your goals, current fitness, and where you are in your training cycle.
                That's not something you need to stress about. As your coach, my job is to
                take care of the planning, programming, and progression. Your job is
                simple: show up and execute the session.
              </p>
            </div>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {CREDS.map((c, i) => {
                const Icon = c.icon;
                return (
                  <li
                    key={i}
                    data-testid={`coach-credential-${i}`}
                    className="bg-[#0e0e10] border border-white/10 p-5 flex flex-col gap-3"
                  >
                    <Icon size={20} className="text-brand-red" />
                    <span className="text-sm text-white/85 leading-snug">{c.label}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
